import { getCheckupValidation } from 'components/cattles/checkupPage/utils/checkupValidation'
import { ICheckupList, PositionHoof } from 'models'
import { Dispatch, SetStateAction, useMemo } from 'react'
import { CardStandart } from 'ui/CardStandart'

import ExtraInfoSection from './components/ExtraInfoSection/ExtraInfoSection'
import { TreatmentSection } from './components/TreatmentSection/TreatmentSection'
type TreatmentCardProps = {
	checkupInfo: ICheckupList
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
	isSubmitAttempted: boolean
	selectedHoof: PositionHoof | null
	setSelectedHoof: Dispatch<SetStateAction<PositionHoof | null>>
}

export const TreatmentCard = ({
	checkupInfo,
	setCheckupInfo,
	isSubmitAttempted,
	selectedHoof,
	setSelectedHoof,
}: TreatmentCardProps) => {
	const { commentInvalid, hasCompleteDiagnosis } = useMemo(
		() => getCheckupValidation(checkupInfo),
		[checkupInfo],
	)

	return (
		<CardStandart
			sx={{
				padding: '24px',
				display: 'flex',
				flexDirection: 'column',
				gap: '24px',
			}}
		>
			<TreatmentSection
				setCheckupInfo={setCheckupInfo}
				checkupInfo={checkupInfo}
				isSubmitAttempted={isSubmitAttempted}
				hasCompleteDiagnosis={hasCompleteDiagnosis}
				selectedHoof={selectedHoof}
				setSelectedHoof={setSelectedHoof}
			/>
			<ExtraInfoSection
				comment={checkupInfo.comment}
				setCheckupInfo={setCheckupInfo}
				isError={isSubmitAttempted && commentInvalid}
			/>
		</CardStandart>
	)
}
